module.exports = __webpack_public_path__ + "img/cloud-2.07e7b5e8.svg";